// removed by extract-text-webpack-plugin
module.exports = {"CalculatorNotes":"CalculatorNotes__CalculatorNotes__2vOgQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CalculatorNotes/CalculatorNotes.css
// module id = 572
// module chunks = 0